export default "__VITE_ASSET__HQrvyM2t__"